import { AxiosRequestConfig } from 'axios';
import { CreateCarPolicyData, UpdateCarPolicyData } from './car-policy.types';
import { IPagination } from '../../hooks/use-table/use-table.props';
import { ConfiguratorLanguages } from 'pages/car-configurator/hooks/use-options-by-type/use-options-by-type.types';

class CarPolicyRequestConfig {
  updateCarPolicy = (data: UpdateCarPolicyData): AxiosRequestConfig => ({
    method: 'POST',
    url: 'policy/updatepolicy',
    data
  });

  createCarPolicy = (data: CreateCarPolicyData): AxiosRequestConfig => ({
    method: 'POST',
    url: 'policy/createpolicy',
    data
  });

  companyList = (Pagination: IPagination | {} = {}): AxiosRequestConfig => ({
    method: 'POST',
    url: 'policy/companylist',
    data: { Pagination },
    transformResponse(data) {
      return data ? JSON.parse(data) : null;
    }
  });

  getCarPolicy = (id: string): AxiosRequestConfig => ({
    method: 'GET',
    url: `policy/${id}`
  });

  policyList = (pagination: IPagination, optionLanguageId: ConfiguratorLanguages): AxiosRequestConfig => ({
    method: 'POST',
    url: 'policy/policyList',
    data: { pagination, optionLanguageId }
  });
}

export const carPolicyRequestConfig = new CarPolicyRequestConfig();
